import type { SVGProps } from 'react'
const SvgSyExport = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<rect width={14} height={6} x={5} y={13} fillOpacity={0.24} rx={2} />
		<path d="M12 5.5a.5.5 0 0 0-.354.146l-2.5 2.5a.5.5 0 0 0 0 .708.5.5 0 0 0 .708 0L11.5 7.207V16a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5V7.207l1.646 1.647a.5.5 0 0 0 .708 0 .5.5 0 0 0 0-.708l-2.5-2.5A.5.5 0 0 0 12 5.5" />
	</svg>
)
export default SvgSyExport
